import React, { Component } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import AdminIntegrationsBody from '../../../components/admin/AdminIntegrationsBody';

// /admin/ops/integrations
export default class AdminIntegrationsScreen extends Component {
  constructor(props) {
    super(props);
    const { isAdmin } = props;
    this.isAdmin = isAdmin;
  }

  render() {
    return (
      <div style={{ height: '100%', textAlign: 'center' }}>
        <PageHeader
          ghost={false}
          title="Integrations"
          subTitle="ops/integrations — one doc, one flat field per setting"
          onBack={() => window.history.back()}
        />
        <AdminIntegrationsBody isAdmin={this.isAdmin} />
      </div>
    );
  }
}
